<template>
  <div class="container">
    <BaseTitle v-if="title">{{ title }}</BaseTitle>
    <div class="cities-grid">
      <NuxtLink
        v-for="city of data?.cities"
        :key="city.id"
        class="city-item"
        :to="localePath({ name: 'cities-slug', params: { slug: city.slug } })"
      >
        {{ city.name }}
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCitiesQuery } from "~~/graphql/generated";

defineProps<{
  title?: string;
}>();

const { data } = await useCitiesQuery({
  variables: {
    // Empty variables...
  },
});

const localePath = useLocalePath();
</script>

<style lang="scss" scoped>
.cities-grid {
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fill, minmax(225px, 1fr));
  @include for-extra-small-screen {
    grid-template-columns: 1fr 1fr;
  }
}

.city-item {
  border-radius: 8px;
  border: 1px solid $light-85;
  padding: 1rem;
  display: flex;
  justify-content: center;
}
</style>
